
import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import DsnGrid from "../DsnGrid";
import { dsnCN } from "../../hooks/helper";
import LazyImg from "../LazyImg";

const BrandDetails = [
  {
    src: "/assets/img/logo/spotify.png",
    title: "Spotify",
    href: "https://open.spotify.com/artist/7435s1bwxVh0coVrNSX7QD?si=x-OmYCFdQSCq_3WGoXlTOA",
  },
  {
    src: "/assets/img/logo/youtube (1).png",
    title: "YouTube",
    href: "https://www.youtube.com/@mystirien?sub_confirmation=1",
  },
  {
    src: "/assets/img/logo/instagram.png",
    title: "Instagram",
    href: "https://www.instagram.com/Mystirien",
  },
  {
    src: "/assets/img/logo/tiktok.png",
    title: "TikTok",
    href: "https://www.tiktok.com/@mystirien",
  },
  {
    src: "/assets/img/logo/X.png",
    title: "X",
    href: "https://x.com/mystirien",
  },
  {
    src: "/assets/img/logo/apple.png",
    title: "Apple Music",
    href: "https://music.apple.com/us/artist/mystirien/1864939108",
  },
];

function BrandClient({ className, ...restProps }) {
  return (
    <DsnGrid className={dsnCN("wrapper-brand", className)} {...restProps}>
      {BrandDetails.map((item, index) => {
        return (
          <div key={index} className="brand-item background-section">
            <div className="box-img ">
              <LazyImg src={item.src} alt="" height={48} width={48} />
            </div>
            <div className="info">
              <div className="content">
                <div className="icon">
                  <FontAwesomeIcon icon={faPlus} />
                </div>

                <div className="entry">
                  <div>
                    <h5 className="mb-20">{item.title}</h5>
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      [ link ]
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </DsnGrid>
  );
}

export default BrandClient;
